import { render, staticRenderFns } from "./TipsPayAtTheTableStatus.vue?vue&type=template&id=4d71b29b"
import script from "./TipsPayAtTheTableStatus.vue?vue&type=script&lang=js"
export * from "./TipsPayAtTheTableStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports